'use client';

import { type GetUserDesignsParams, getUserDesigns } from '@/api/getUserDesigns';
import { useCursorInfiniteScroll } from '@/hooks/useCursorInfiniteScroll';
import type { UserDesignItem } from '@/types';
import { useCallback, useRef } from 'react';

/**
 * ユーザーデザインの無限スクロール用hook
 * 汎用 useCursorInfiniteScroll に getUserDesigns の fetcher を渡すラッパー
 */
export function useUserDesignInfiniteScroll({
  initialDesigns,
  initialHasMore,
  apiParams,
}: {
  initialDesigns: UserDesignItem[];
  initialHasMore: boolean;
  apiParams?: Omit<GetUserDesignsParams, 'lastId' | 'direction'>;
}) {
  const apiParamsRef = useRef(apiParams);
  apiParamsRef.current = apiParams;

  const fetcher = useCallback(async (lastId: number) => {
    const res = await getUserDesigns({ ...apiParamsRef.current, lastId, direction: 'next' });
    return res.result;
  }, []);

  const { data, hasMore, isLoading, loadMore } = useCursorInfiniteScroll({
    initialData: initialDesigns,
    initialHasMore,
    fetcher,
  });

  return { visibleDesigns: data, hasMore, isLoading, loadMore };
}
